var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "copy",
    transform: "translate(-32 -32)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38791",
    "data-name": "Path 38791",
    d: "M125.214,128.429h-10A3.214,3.214,0,0,1,112,125.214v-10A3.214,3.214,0,0,1,115.214,112h10a3.214,3.214,0,0,1,3.214,3.214v10A3.214,3.214,0,0,1,125.214,128.429Z",
    transform: "translate(-76.429 -76.429)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38792",
    "data-name": "Path 38792",
    d: "M37.714,34.143h10.53A3.22,3.22,0,0,0,45.214,32h-10A3.214,3.214,0,0,0,32,35.214v10a3.22,3.22,0,0,0,2.143,3.03V37.714A3.571,3.571,0,0,1,37.714,34.143Z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.7ae26bddcf084f3b00d9e7a9b8fc75f4.svg";
export { ForwardRef as ReactComponent };